import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { HeaderBaseComponent, TicketStatus } from '@resident-nx/shared';
import { StatusBadgeWebComponent } from '../../../../atoms/status-badge/status-badge.component';
import { IconWebComponent } from '@resident-nx/web/ui';
import { LabelWebComponent } from '../../../../atoms/label/label.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'rs-web-ticket-details-header',
  templateUrl: 'ticket-details-header.component.html',
  styleUrls: ['ticket-details-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StatusBadgeWebComponent, IconWebComponent, LabelWebComponent, TranslateModule],
})
export class TicketDetailsHeaderWebComponent extends HeaderBaseComponent {
  @Input() state: TicketStatus;
  @Input() deleteButton = false;
  @Output() closeEvent = new EventEmitter();
  @Output() cancelTicketEvent = new EventEmitter();

  /**
   * Copies the externalId to the clipboard and shows the 'Copied' label for 1.5 seconds.
   * @param externalId The external ticket ID to copy
   */
  copy(externalId: string): void {
    navigator.clipboard.writeText(externalId).then(() => {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
        this.cdr.markForCheck();
      }, this.disappearTime);
    });
  }
}
